import { DISPATCH_METHODS } from '~constants/address';
import IcDeliveryWhite from '~assets/templates/sushi/ic_delivery_white.svg';
import IcDeliveryBlack from '~assets/templates/sushi/ic_delivery_black.svg';
import IcInStoreBlack from '~assets/templates/sushi/ic_in_store_black.svg';
import IcInStoreWhite from '~assets/templates/sushi/ic_in_store_white.png';

export const PROFILE_MENU = 'profileMenu';
export const LOGO = 'logo';
export const ACTION_LINKS = 'actionLinks';
export const MINI_CART = 'miniCart';

export const DELIVERY_ICONS_MAPPER = {
  [DISPATCH_METHODS.DELIVERY]: {
    active: IcDeliveryBlack,
    inactive: IcDeliveryWhite
  },
  [DISPATCH_METHODS.PICKUP]: {
    active: IcInStoreBlack,
    inactive: IcInStoreWhite
  }
};
